import type { Transaction } from "@rocicorp/zero";
import { userFacingError } from "../authorization";
import { type Schema, zql } from "../generatedDrizzleSchema";

export async function applyToolResult(
  tx: Transaction<Schema>,
  args: {
    chatId: string;
    entryId: string;
    // TOOL_CALL_OUTPUT_V1_BACKCOMPAT start
    outputId?: string;
    // TOOL_CALL_OUTPUT_V1_BACKCOMPAT end
    isError?: boolean;
  }
) {
  const [entry] = await tx.run(
    zql.chatEntries.where("id", args.entryId).where("chatId", args.chatId)
  );
  if (!entry) throw userFacingError(`Entry not found: ${args.entryId}`);

  const [toolCallEntry] = await tx.run(
    zql.toolCalls.where("entryId", args.entryId)
  );
  if (!toolCallEntry) {
    throw userFacingError(`Tool call not found: ${args.entryId}`);
  }
  if (toolCallEntry.completedAt !== null) {
    throw userFacingError("Tool call already completed");
  }

  await tx.mutate.toolCalls.update({
    entryId: toolCallEntry.entryId,
    // TOOL_CALL_OUTPUT_V1_BACKCOMPAT start
    ...(args.outputId ? { outputBlobId: args.outputId } : {}),
    // TOOL_CALL_OUTPUT_V1_BACKCOMPAT end
    isError: args.isError ?? false,
    completedAt: Date.now(),
  });
}
